import { z } from "zod";

export const PERSONAL_ROLE_PARTS = [
  "name",
  "color",
  "gradient",
  "holographic",
  "icon",
  "hoist",
] as const;

export type PersonalRolePart = (typeof PERSONAL_ROLE_PARTS)[number];

export const personalRolePartsSchema = z
  .array(z.enum(PERSONAL_ROLE_PARTS))
  .min(1)
  .max(PERSONAL_ROLE_PARTS.length)
  .refine((parts) => new Set(parts).size === parts.length, {
    message: "each part is listed once",
  })
  .refine((parts) => parts.includes("name"), { message: "a personal role always has its name" });

export const personalRolePartsHeld = (
  held: readonly (readonly PersonalRolePart[])[],
): readonly PersonalRolePart[] => {
  const parts = new Set(held.flat());
  return PERSONAL_ROLE_PARTS.filter((part) => parts.has(part));
};
